import React, { useEffect, useRef } from 'react';
import { Button } from '..';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
} from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';
import { useTranslation } from '../../shared/hooks';
import * as translations from './intl';
import * as cookiesPolicy from './intl.cookies';

const w25 = { width: '25%' };
const w50 = { width: '50%' };

export default function CookiePolicyUSChubb({
  showCookiesPolicyUSChubb,
  handleShowCookiesPolicy,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const { locale: intl } = useTranslation({
    translationsFile: translations,
  });
  const { locale: policy } = useTranslation({
    translationsFile: cookiesPolicy,
  });
  const TermsElementRef = useRef(null);

  useEffect(() => {
    if (showCookiesPolicyUSChubb) {
      const { current: descriptionElement } = TermsElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [showCookiesPolicyUSChubb]);

  const { COOKIES, CLOSE } = intl;

  const {
    MAIN_COOKIE_TEXT,
    HOW_COLLECTS_YOUR_PERSONAL_DATA_TITLE,
    HOW_COLLECTS_YOUR_PERSONAL_DATA_TEXT,
    WHAT_ARE_COOKIES_TITLE,
    WHAT_ARE_COOKIES_TEXT1,
    WHAT_ARE_COOKIES_TEXT2,
    WHAT_ARE_COOKIES_LIST,
    WHAT_ARE_COOKIES_TEXT3,
    WHAT_ARE_COOKIES_TEXT4,
    WHAT_ARE_COOKIES_TEXT5,
    TYPES_OF_COOKIES_USED_TITLE,
    TYPES_OF_COOKIES_USED_TEXT,
    TYPES_OF_COOKIES_USED_LIST,
    COOKIE_LIST_TITLE,
    COOKIE_LIST_TEXT1,
    COOKIE_TABLES_TITLE,
    FUNCTIONAL_TECHNICAL_COOKIES_TITLE,
    FUNCTIONAL_TECHNICAL_COOKIES_TEXT,
    TABLE_HEAD,
    ANALYTICS_COOKIES_TITLE,
    ANALYTICS_COOKIES_TEXT,
    MARKETING_COOKIES_TITLE,
    MARKETING_COOKIES_TEXT,
    WHAT_ARE_YOUR_RIGHTS_RELATED_TITLE,
    WHAT_ARE_YOUR_RIGHTS_RELATED_TEXT,
    HOW_TO_CONTACT_TITLE,
    HOW_TO_CONTACT_TEXT,
    UPDATES_TITLE,
    UPDATES_TEXT,
    UPDATE_OF_PRESENT_POLICY_TITLE,
    UPDATE_OF_PRESENT_POLICY_TEXT,
    MORE_INFO_TITLE,
    FIRST_PARTY,
    COOKIE_DEPOSIT_MANDATORY_TITLE,
    COOKIE_DEPOSIT_MANDATORY_TEXT,
  } = policy;

  return (
    <>
      <DialogTitle id="cookies-policy" onClose={handleShowCookiesPolicy}>
        {COOKIES}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText component="div">
          <ListItem>
            <p dangerouslySetInnerHTML={{ __html: MAIN_COOKIE_TEXT }} />
          </ListItem>
          <ListItem>
            <strong>{HOW_COLLECTS_YOUR_PERSONAL_DATA_TITLE}</strong>
            <p
              dangerouslySetInnerHTML={{
                __html: HOW_COLLECTS_YOUR_PERSONAL_DATA_TEXT,
              }}
            />
          </ListItem>
          <ListItem
            dangerouslySetInnerHTML={{
              __html: `
                <strong>${WHAT_ARE_COOKIES_TITLE}</strong>
                <br />
                <p>${WHAT_ARE_COOKIES_TEXT1}</p>
                <p>${WHAT_ARE_COOKIES_TEXT2}</p>
                <ul>
                 ${WHAT_ARE_COOKIES_LIST.map((el) => `<li>${el}</li>`).join('')}
                </ul>
                <p>${WHAT_ARE_COOKIES_TEXT3}</p>
                <p>${WHAT_ARE_COOKIES_TEXT4}</p>
                <p>${WHAT_ARE_COOKIES_TEXT5}</p>
                <p>${TYPES_OF_COOKIES_USED_LIST}</p>
          `,
            }}
          />
          <ListItem>
            <strong>{TYPES_OF_COOKIES_USED_TITLE}</strong>
            <p>{TYPES_OF_COOKIES_USED_TEXT}</p>
            {/* <p>
              <ul>
                {TYPES_OF_COOKIES_USED_LIST.map((el, index) => (
                  <li key={index}>{el}</li>
                ))}
              </ul>
            </p> */}
            {/* <p>
              <strong>{COOKIE_LIST_TITLE}</strong>
            </p>
            <p>{COOKIE_LIST_TEXT1}</p> */}
            <p>
              <strong>{COOKIE_TABLES_TITLE}</strong>
            </p>
            <p>
              <strong>{FUNCTIONAL_TECHNICAL_COOKIES_TITLE}</strong>
            </p>
            <p>{FUNCTIONAL_TECHNICAL_COOKIES_TEXT}</p>
            <p>
              <div id="ot-sdk-cookie-policy"></div>
            </p>
            <p>
              <strong>{ANALYTICS_COOKIES_TITLE}</strong>
            </p>
            <p>{ANALYTICS_COOKIES_TEXT}</p>

            <p>
              <strong>{MARKETING_COOKIES_TITLE}</strong>
            </p>
            <p>{MARKETING_COOKIES_TEXT}</p>
            <p></p>
          </ListItem>
          <ListItem>
            <strong>{WHAT_ARE_YOUR_RIGHTS_RELATED_TITLE}</strong>
            <p
              dangerouslySetInnerHTML={{
                __html: WHAT_ARE_YOUR_RIGHTS_RELATED_TEXT,
              }}
            />
          </ListItem>
          <ListItem>
            <strong>{HOW_TO_CONTACT_TITLE}</strong>
            <p dangerouslySetInnerHTML={{ __html: HOW_TO_CONTACT_TEXT }} />
          </ListItem>
          <ListItem>
            <strong>{UPDATES_TITLE}</strong>
            <p dangerouslySetInnerHTML={{ __html: UPDATES_TEXT }} />
          </ListItem>
          <ListItem>
            <strong>{COOKIE_DEPOSIT_MANDATORY_TITLE}</strong>
            <p
              dangerouslySetInnerHTML={{
                __html: COOKIE_DEPOSIT_MANDATORY_TEXT,
              }}
            />
          </ListItem>
          <ListItem>
            <strong>{UPDATE_OF_PRESENT_POLICY_TITLE}</strong>
            <p>{UPDATE_OF_PRESENT_POLICY_TEXT}</p>
          </ListItem>
          <ListItem>
            <strong>{MORE_INFO_TITLE}</strong>
          </ListItem>
        </DialogContentText>
      </DialogContent>
    </>
  );
}

const ListItem = styled('li')({
  paddingTop: '2em',
  display: 'block',
});

const Table = styled('table')({
  border: '1px solid #d7d7d7',
  width: '100%',
  borderRadius: '5px',
});

const TH = styled('th')({
  padding: '0.5em',
  border: '1px solid #d7d7d7',
});

const TD = styled('td')({
  padding: '0.5em',
  fontSize: '0.8em',
  border: '1px solid #d7d7d7',
  wordWrap: 'break-word',
});
